// extracted by mini-css-extract-plugin
export var ArticleContainer = "ArticleLeftRightSection-module--ArticleContainer--85666";
export var ArticleContainerReverse = "ArticleLeftRightSection-module--ArticleContainerReverse--097eb";
export var articleContent = "ArticleLeftRightSection-module--articleContent--f9ef7";
export var articleImage = "ArticleLeftRightSection-module--articleImage--d4769";
export var capitalize = "ArticleLeftRightSection-module--capitalize--e7025";
export var date = "ArticleLeftRightSection-module--date--45c34";
export var fs14 = "ArticleLeftRightSection-module--fs-14--c7fd1";
export var fs16 = "ArticleLeftRightSection-module--fs-16--9310c";
export var fs20 = "ArticleLeftRightSection-module--fs-20--51d2a";
export var fs24 = "ArticleLeftRightSection-module--fs-24--01a5b";
export var fs32 = "ArticleLeftRightSection-module--fs-32--8cd8f";
export var fs40 = "ArticleLeftRightSection-module--fs-40--c12c6";
export var fsItalic = "ArticleLeftRightSection-module--fs-italic--cd28d";
export var fsLg = "ArticleLeftRightSection-module--fs-lg--7c5c7";
export var fsMd = "ArticleLeftRightSection-module--fs-md--90bed";
export var fsNormal = "ArticleLeftRightSection-module--fs-normal--09686";
export var fsSm = "ArticleLeftRightSection-module--fs-sm--4f0f9";
export var fsXl = "ArticleLeftRightSection-module--fs-xl--6db06";
export var fsXs = "ArticleLeftRightSection-module--fs-xs--61c75";
export var fsXxl = "ArticleLeftRightSection-module--fs-xxl--1d654";
export var fsXxs = "ArticleLeftRightSection-module--fs-xxs--7890b";
export var fwBold = "ArticleLeftRightSection-module--fw-bold--50e25";
export var fwMedium = "ArticleLeftRightSection-module--fw-medium--d8555";
export var fwNormal = "ArticleLeftRightSection-module--fw-normal--8041b";
export var gotham_bold = "ArticleLeftRightSection-module--gotham_bold--3d763";
export var gotham_bold_italic = "ArticleLeftRightSection-module--gotham_bold_italic--f336b";
export var gotham_book = "ArticleLeftRightSection-module--gotham_book--517f1";
export var gotham_book_italic = "ArticleLeftRightSection-module--gotham_book_italic--37b3b";
export var icon = "ArticleLeftRightSection-module--icon--5f109";
export var iconContainer = "ArticleLeftRightSection-module--iconContainer--ddf76";
export var lowercase = "ArticleLeftRightSection-module--lowercase--a7923";
export var tag = "ArticleLeftRightSection-module--tag--71ad4";
export var tags = "ArticleLeftRightSection-module--tags--d439c";
export var tagsContainer = "ArticleLeftRightSection-module--tagsContainer--6971a";
export var tagsSwiper = "ArticleLeftRightSection-module--tagsSwiper--d810d";
export var title = "ArticleLeftRightSection-module--title--9f4ba";
export var uppercase = "ArticleLeftRightSection-module--uppercase--11051";